/**
 * CORE-1205 — как экрану, которому нужен звонок, выйти из идущей сессии.
 *
 * Выход живёт в слое сессии (`LiveSessionHost.native`): там вью-модель комнаты
 * и диалог ведущего. Экраны превью, зрителя и эфира мастера до слоя не
 * дотягиваются, а через общий контекст пришлось бы менять провайдер, который
 * оборачивает и веб. Сессия на устройстве одна, поэтому хватает одной ячейки:
 * слой кладёт сюда ручку, пока сессия смонтирована, и забирает при уходе.
 */

export interface ActiveSessionExit {
  roomId: string;
  /** Название — чтобы вопрос называл, из чего выходить. */
  getTitle: () => string;
  /**
   * Выйти ради другого экрана. Вопрос уже задан сторожем, поэтому участник
   * выходит сразу; ведущий идущей сессии получает свой выбор (передать /
   * завершить / остаться). `onStayed` — ведущий выбрал остаться.
   */
  exitForConflict: (onStayed: () => void) => void;
}

let active: ActiveSessionExit | null = null;

/** Положить ручку; возвращает уборку, которая не снимет чужую, более новую. */
export function registerActiveSessionExit(handle: ActiveSessionExit): () => void {
  active = handle;
  return () => {
    if (active === handle) active = null;
  };
}

export function getActiveSessionExit(): ActiveSessionExit | null {
  return active;
}
